import React from 'react';
import { connect } from 'react-redux';
import {
  Box, Typography, Button, makeStyles, Paper,
} from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/Error';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
    padding: theme.spacing(2),
  },
  errorCard: {
    backgroundColor: theme.body.errorCard.backgroundColor,
    borderRadius: '20px',
    paddingTop: '48px',
    paddingBottom: '40px',
    paddingLeft: '74px',
    paddingRight: '74px',
    textAlign: 'center',
    boxShadow: `0px 10px 25px ${theme.body.errorCard.boxShadow}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    fontSize: '80px',
    color: theme.body.errorCard.icon,
    marginBottom: '25px',
  },
  title: {
    fontWeight: 700,
    color: theme.body.errorCard.title,
    fontSize: '28px',
    marginBottom: '15px',
    fontFamily: '"Karla"',
  },
  description: {
    fontWeight: 500,
    color: theme.body.errorCard.description,
    marginBottom: '15px',
    fontSize: '20px',
    lineHeight: '1.5rem',
    fontFamily: '"Karla"',
  },
  retryButton: {
    backgroundColor: theme.body.errorCard.retryButtonBackgroundColor,
    color: theme.body.errorCard.retryButtonColor,
    padding: '12px 0',
    width: '120px',
    borderRadius: '10px',
    fontWeight: 700,
    textTransform: 'none',
    marginTop: '15px',
    '&:hover': {
      backgroundColor: theme.body.errorCard.hover,
    },
    fontFamily: '"Karla"',
  },
}));

const Error = (props) => {
  const { redirectUrl } = props;

  const classes = useStyles();

  const handleRetry = () => {
    window.location.href = redirectUrl;
  };

  return (
    <Box className={classes.container}>
      <Paper elevation={0} className={classes.errorCard}>
        <ErrorOutlineIcon className={classes.icon} />
        <Typography variant="h2" className={classes.title}>
          ¡Oh oh!
        </Typography>
        <Typography className={classes.description}>
          Ha ocurrido un error en la plataforma, por favor,
          {' '}
          <br />
          {' '}
          inténtalo de nuevo.
        </Typography>
        <Button
          variant="contained"
          className={classes.retryButton}
          onClick={handleRetry}
        >
          <Typography
            style={{
              fontFamily: '"Karla"',
              fontSize: '16px',
              letterSpacing: '0.5px',
            }}
          >
            Reintentar
          </Typography>
        </Button>
      </Paper>
    </Box>
  );
};

const mapStateToProps = (props) => ({
  redirectUrl: props.license.redirectUrl,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(Error);
